var map = {
	"./views/HK/m/shop/index": [
		"9c32",
		"chunk-2cd81fe9",
		"chunk-443ca35e"
	],
	"./views/HK/shop/index": [
		"2e82",
		"chunk-2cd81fe9",
		"chunk-2d0cfb23",
		"chunk-c2b6b35e"
	],
	"./views/dayu/shop/index": [
		"556d",
		"chunk-b2230b06"
	],
	"./views/m/shop/index": [
		"1ee7",
		"chunk-2cd81fe9",
		"chunk-36358b56"
	],
	"./views/shop/index": [
		"0bad",
		"chunk-2cd81fe9",
		"chunk-2d0cfb23",
		"chunk-7b89ff95"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "b909";
module.exports = webpackAsyncContext;